import { createElement } from "react"
import { AppRouteConfig } from "@/types/navigation"
import { ROUTES } from "./path"
import Settings from "@/pages/dashboard/settings"

export const settingsRoutes: AppRouteConfig[] = [
  {
    path: ROUTES.DASHBOARD.SETTINGS.INDEX,
    element: createElement(Settings),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.SETTINGS.GENERAL,
    element: createElement(Settings),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.SETTINGS.TEAM,
    element: createElement(Settings),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.SETTINGS.CREDITS,
    element: createElement(Settings),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.SETTINGS.BILLING,
    element: createElement(Settings),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.SETTINGS.DEVELOPER,
    element: createElement(Settings),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
]
